import { ImpersonateDropdown, Layout, Toast, UserMenu } from '@aon/aon-tws-common-ui';
import surveyBuilderLogo from '@aon/aon-tws-common-ui/build/lib/assets/images/logo-surveyBuilder.svg';
import { Permission, PermissionUtil } from '@aon/aon-tws-common-ui/build/lib/components/Permission';
import { UserSessionManager } from '@aon/aon-tws-common-ui/build/lib/components/Session/UserSessionManager';
import * as React from 'react';
import Constants from '../../constants';
import { ClientContextContainer } from '../../containers/ClientContext/ClientContextSwitch';
import ContentConstants from '../../contentConstants';
import PermissionConstants from '../../permissionConstants';
import userManager from '../../userManager';
import { IProgressPanelProps, ProgressPanel } from '../pages/survey-admin/ProgressPanel';
import { LayoutProps } from './Layout';

export class AdminLayout extends React.Component<React.PropsWithChildren<LayoutProps & IProgressPanelProps>, {}> {
	public render() {
		const impersonatorName = this.props.user && this.props.user.profile.impersonator_name;
		const userHasAccessToApp = PermissionUtil.GetUserApplications().indexOf(PermissionConstants.ApplicationName) > -1;
		const isInternal = this.props.user && this.props.user.profile.package === Constants.PACKAGE_INTERNAL;

		return (
			<div>
				{impersonatorName && (
					<ImpersonateDropdown
						impersonatorName={impersonatorName}
						identityServerUrl={Constants.IDENTITY_SERVER_URL}
						userManager={userManager}
					/>
				)}
				<Layout
					headerProps={{
						menuModel: this.props.headerMenuItems,
						displayHeaderNavigation: true,
						environment: Constants.BRANCH_ENVIRONMENT,
					}}
					applicationLogoProps={{ logoSrc: surveyBuilderLogo, mobileLogoSrc: surveyBuilderLogo, showSideNavMenu: false }}
					userMenu={() => this.getUserMenu()}
					clientContextSelector={() => {
						return (
							userHasAccessToApp && (
								<ClientContextContainer
									identityServerUrl={Constants.IDENTITY_SERVER_URL}
									userManagementBaseUrl={Constants.USER_MANAGEMENT_API_URL}
								/>
							)
						);
					}}
					sidePadProps={{
						headerText: this.props.audienceId
							? ContentConstants.SURVEY_ADMIN_AUDIENCE_SIDE_PAD_HEADER
							: ContentConstants.SURVEY_ADMIN_SIDE_PAD_HEADER,
					}}
					sidePad={() => (
						<Permission {...PermissionConstants.SURVEYBUILDER_ALL}>
							<ProgressPanel {...this.props} />
						</Permission>
					)}
					footerProps={{ isInternal, isLlc: Constants.IS_LLC, releaseVersion: Constants.APP_RELEASE_NUMBER }}
					domainName={Constants.DOMAIN_NAME}
				>
					<UserSessionManager
						sessionKeyPrefix='SB'
						clientLogoutUrl={Constants.API_CLIENT_LOGOUT_URL}
						identityServerUrl={Constants.IDENTITY_SERVER_URL}
						landingPageRoute={Constants.ADMINPORTAL_URL + Constants.ROUTE_LANDING}
						timeoutInSeconds={Constants.SESSION_TIMEOUT}
						userManager={userManager}
					/>
					<Permission {...PermissionConstants.SURVEYBUILDER_ALL}>{this.props.children}</Permission>
					{this.props.notifications.instance !== undefined && (
						<Toast key={this.props.notifications.key} {...this.props.notifications.instance} />
					)}
				</Layout>
			</div>
		);
	}

	public getUserMenu() {
		return this.props.user ? (
			<UserMenu userName={this.props.user.profile.name} href={'#'} userMenuOptions={this.props.loggedInUserMenuOptions} />
		) : undefined;
	}
}
